// src/pages/TikpagExperience/TikpagExperiencePinsEntregas.jsx

import React, {
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";

import {
  Box,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleDot,
  ExternalLink,
  Filter,
  Loader2,
  MapPin,
  PackageCheck,
  PackageOpen,
  RefreshCcw,
  Search,
  Send,
  Truck,
  UserCheck,
  X
} from "lucide-react";

import axios from "../../axiosConfig";

import {
  getPinImage
} from "../../utils/pinAssets";

import "./TikpagExperiencePinsEntregas.css";

const MESES = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro"
];

const STATUS_PIN = [
  { value: "", label: "Todos os status" },
  { value: "PENDENTE", label: "Pendente" },
  { value: "EM_PRODUCAO", label: "Em produção" },
  { value: "PRONTO", label: "Pronto" },
  { value: "ENVIADO", label: "Enviado" },
  { value: "ENTREGUE", label: "Entregue" },
  { value: "RETIRADO", label: "Retirado" }
];

const TIPOS_ENTREGA = [
  { value: "", label: "Todos os tipos" },
  { value: "ENVIO", label: "Envio" },
  { value: "RETIRADA", label: "Retirada" }
];

const FORM_INICIAL = {
  status_pin: "PENDENTE",
  tipo_entrega: "ENVIO",
  destinatario: "",
  telefone: "",
  cep: "",
  logradouro: "",
  numero: "",
  complemento: "",
  bairro: "",
  cidade: "",
  estado: "",
  transportadora: "",
  codigo_rastreio: "",
  link_rastreio: "",
  observacoes: ""
};

const hoje = new Date();

const formatarDinheiro = (valor) =>
  Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL"
  });

const formatarDataHora = (valor) => {
  if (!valor) return "-";

  const texto = String(valor)
    .replace("T", " ")
    .replace("Z", "");

  const [data, hora] = texto.split(" ");
  const [ano, mes, dia] = String(data || "")
    .slice(0, 10)
    .split("-");

  if (!ano || !mes || !dia) {
    return valor;
  }

  return `${dia}/${mes}/${ano}${
    hora ? ` ${hora.slice(0, 5)}` : ""
  }`;
};

const formatarCnpj = (valor) => {
  const numeros = String(valor || "")
    .replace(/\D/g, "");

  if (numeros.length !== 14) {
    return valor || "-";
  }

  return numeros.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );
};

const statusLabel = (status) =>
  String(status || "")
    .replaceAll("_", " ")
    .toLowerCase()
    .replace(
      /(^|\s)\S/g,
      (letra) => letra.toUpperCase()
    );

export default function TikpagExperiencePinsEntregas() {
  const [campanhas, setCampanhas] =
    useState([]);

  const [campanhaId, setCampanhaId] =
    useState("");

  const [ano, setAno] =
    useState(hoje.getFullYear());

  const [mes, setMes] =
    useState(hoje.getMonth() + 1);

  const [pinId, setPinId] =
    useState("");

  const [statusPin, setStatusPin] =
    useState("");

  const [tipoEntrega, setTipoEntrega] =
    useState("");

  const [busca, setBusca] =
    useState("");

  const [
    buscaAplicada,
    setBuscaAplicada
  ] = useState("");

  const [pagina, setPagina] =
    useState(1);

  const [limite] =
    useState(25);

  const [dados, setDados] =
    useState(null);

  const [linhasAbertas, setLinhasAbertas] =
    useState({});

  const [loading, setLoading] =
    useState(false);

  const [
    loadingCampanhas,
    setLoadingCampanhas
  ] = useState(true);

  const [modalAberto, setModalAberto] =
    useState(false);

  const [detalhe, setDetalhe] =
    useState(null);

  const [loadingDetalhe, setLoadingDetalhe] =
    useState(false);

  const [salvando, setSalvando] =
    useState(false);

  const [form, setForm] =
    useState(FORM_INICIAL);

  const [erro, setErro] =
    useState("");

  const [sucesso, setSucesso] =
    useState("");

  const carregarCampanhas =
    useCallback(async () => {
      setLoadingCampanhas(true);
      setErro("");

      try {
        const resposta =
          await axios.get(
            "/admin/experience/campanhas"
          );

        const lista = Array.isArray(
          resposta.data?.campanhas
        )
          ? resposta.data.campanhas
          : [];

        setCampanhas(lista);

        setCampanhaId((atual) => {
          if (atual) return atual;

          const preferida =
            lista.find(
              (item) =>
                item.status ===
                "EM_ANDAMENTO"
            ) ||
            lista.find(
              (item) =>
                item.status ===
                "INSCRICOES"
            ) ||
            lista[0];

          return preferida
            ? String(preferida.id)
            : "";
        });
      } catch (err) {
        setErro(
          err.response?.data?.error ||
            "Não foi possível carregar as campanhas."
        );
      } finally {
        setLoadingCampanhas(false);
      }
    }, []);

  useEffect(() => {
    carregarCampanhas();
  }, [carregarCampanhas]);

  const carregarEntregas =
    useCallback(async () => {
      if (!campanhaId) return;

      setLoading(true);
      setErro("");

      try {
        const resposta =
          await axios.get(
            "/admin/experience/pins-entregas",
            {
              params: {
                campanha_id:
                  Number(campanhaId),
                pagina,
                limite,
                ano:
                  Number(ano) ||
                  undefined,
                mes:
                  Number(mes) ||
                  undefined,
                pin_id:
                  pinId
                    ? Number(pinId)
                    : undefined,
                status_pin:
                  statusPin ||
                  undefined,
                tipo_entrega:
                  tipoEntrega ||
                  undefined,
                busca:
                  buscaAplicada ||
                  undefined
              }
            }
          );

        setDados(
          resposta.data || null
        );
      } catch (err) {
        console.error(
          "Erro ao carregar entregas Experience:",
          err
        );

        setErro(
          err.response?.data?.error ||
            "Não foi possível carregar as entregas dos PINs."
        );
      } finally {
        setLoading(false);
      }
    }, [
      campanhaId,
      pagina,
      limite,
      ano,
      mes,
      pinId,
      statusPin,
      tipoEntrega,
      buscaAplicada
    ]);

  useEffect(() => {
    carregarEntregas();
  }, [carregarEntregas]);

  const aplicarBusca = () => {
    setPagina(1);
    setBuscaAplicada(
      busca.trim()
    );
  };

  const limparFiltros = () => {
    setAno(hoje.getFullYear());
    setMes(hoje.getMonth() + 1);
    setPinId("");
    setStatusPin("");
    setTipoEntrega("");
    setBusca("");
    setBuscaAplicada("");
    setPagina(1);
  };

  const alternarLinha = (id) => {
    setLinhasAbertas(
      (estadoAtual) => ({
        ...estadoAtual,
        [id]:
          !estadoAtual[id]
      })
    );
  };

  const abrirEdicao = async (
    conquistaId
  ) => {
    setModalAberto(true);
    setLoadingDetalhe(true);
    setDetalhe(null);
    setErro("");
    setSucesso("");

    try {
      const resposta =
        await axios.get(
          `/admin/experience/pins-entregas/${conquistaId}`
        );

      const registro =
        resposta.data || null;

      setDetalhe(registro);

      const entrega =
        registro?.entrega;

      const sugestao =
        registro?.sugestao_inicial ||
        {};

      setForm({
        status_pin:
          registro?.pin?.status ||
          "PENDENTE",

        tipo_entrega:
          entrega?.tipo ||
          sugestao.tipo_entrega ||
          "ENVIO",

        destinatario:
          entrega?.destinatario ||
          sugestao.destinatario ||
          "",

        telefone:
          entrega?.telefone ||
          sugestao.telefone ||
          "",

        cep:
          entrega?.endereco?.cep ||
          sugestao.cep ||
          "",

        logradouro:
          entrega?.endereco
            ?.logradouro || "",

        numero:
          entrega?.endereco
            ?.numero || "",

        complemento:
          entrega?.endereco
            ?.complemento || "",

        bairro:
          entrega?.endereco
            ?.bairro || "",

        cidade:
          entrega?.endereco
            ?.cidade ||
          sugestao.cidade ||
          "",

        estado:
          entrega?.endereco
            ?.estado ||
          sugestao.estado ||
          "",

        transportadora:
          entrega?.rastreio
            ?.transportadora || "",

        codigo_rastreio:
          entrega?.rastreio
            ?.codigo || "",

        link_rastreio:
          entrega?.rastreio
            ?.link || "",

        observacoes:
          entrega?.observacoes ||
          ""
      });
    } catch (err) {
      setErro(
        err.response?.data?.error ||
          "Não foi possível carregar os detalhes da entrega."
      );
    } finally {
      setLoadingDetalhe(false);
    }
  };

  const fecharModal = () => {
    if (salvando) return;

    setModalAberto(false);
    setDetalhe(null);
    setForm(FORM_INICIAL);
  };

  const atualizarCampo = (
    campo,
    valor
  ) => {
    setForm((atual) => ({
      ...atual,
      [campo]: valor
    }));
  };

  const salvarEntrega = async () => {
    const conquistaId =
      detalhe?.conquista?.id;

    if (!conquistaId) return;

    if (
      form.tipo_entrega ===
        "RETIRADA" &&
      ["ENVIADO", "ENTREGUE"].includes(
        form.status_pin
      )
    ) {
      setErro(
        "Para retirada, use o status Retirado."
      );
      return;
    }

    if (
      form.tipo_entrega ===
        "ENVIO" &&
      form.status_pin ===
        "RETIRADO"
    ) {
      setErro(
        "O status Retirado exige o tipo Retirada."
      );
      return;
    }

    setSalvando(true);
    setErro("");
    setSucesso("");

    try {
      const resposta =
        await axios.put(
          `/admin/experience/pins-entregas/${conquistaId}`,
          {
            status_pin:
              form.status_pin,
            tipo_entrega:
              form.tipo_entrega,
            destinatario:
              form.destinatario,
            telefone:
              form.telefone,
            cep:
              form.cep,
            logradouro:
              form.logradouro,
            numero:
              form.numero,
            complemento:
              form.complemento,
            bairro:
              form.bairro,
            cidade:
              form.cidade,
            estado:
              form.estado,
            transportadora:
              form.transportadora,
            codigo_rastreio:
              form.codigo_rastreio,
            link_rastreio:
              form.link_rastreio,
            observacoes:
              form.observacoes
          }
        );

      setSucesso(
        resposta.data?.message ||
          "Entrega atualizada com sucesso."
      );

      await carregarEntregas();

      fecharModal();
    } catch (err) {
      console.error(
        "Erro ao atualizar entrega Experience:",
        err
      );

      setErro(
        err.response?.data?.error ||
          "Não foi possível atualizar a entrega."
      );
    } finally {
      setSalvando(false);
    }
  };

  const entregas =
    Array.isArray(dados?.entregas)
      ? dados.entregas
      : [];

  const pins =
    Array.isArray(
      dados?.filtros?.pins
    )
      ? dados.filtros.pins
      : [];

  const paginacao =
    dados?.paginacao || {
      pagina: 1,
      total_paginas: 1,
      total_registros: 0
    };

  const cards = useMemo(
    () => [
      {
        titulo: "Pendentes",
        valor:
          dados?.cards?.pendentes || 0,
        legenda:
          "Aguardando início do fluxo",
        Icone: CircleDot,
        classe: "pendente"
      },
      {
        titulo: "Em produção",
        valor:
          dados?.cards
            ?.em_producao || 0,
        legenda:
          "PINs em fabricação",
        Icone: PackageOpen,
        classe: "producao"
      },
      {
        titulo: "Prontos",
        valor:
          dados?.cards?.prontos || 0,
        legenda:
          "Disponíveis para envio",
        Icone: PackageCheck,
        classe: "pronto"
      },
      {
        titulo: "Enviados",
        valor:
          dados?.cards?.enviados || 0,
        legenda:
          "Com transportadora",
        Icone: Send,
        classe: "enviado"
      },
      {
        titulo: "Entregues",
        valor:
          dados?.cards?.entregues || 0,
        legenda:
          "Entregas concluídas",
        Icone: Truck,
        classe: "entregue"
      },
      {
        titulo: "Retirados",
        valor:
          dados?.cards?.retirados || 0,
        legenda:
          "Retirada confirmada",
        Icone: UserCheck,
        classe: "retirado"
      }
    ],
    [dados]
  );

  return (
    <div className="experiencePinsEntregas-page">
      <header className="experiencePinsEntregas-header">
        <div>
          <span className="experiencePinsEntregas-kicker">
            Tikpag Experience
          </span>

          <h1>
            Entrega dos PINs
          </h1>

          <p>
            Controle produção, envio, retirada,
            rastreamento e conclusão das entregas
            físicas.
          </p>
        </div>

        <button
          type="button"
          className="experiencePinsEntregas-refreshButton"
          onClick={carregarEntregas}
          disabled={
            loading ||
            loadingCampanhas
          }
        >
          <RefreshCcw
            size={16}
            className={
              loading
                ? "experiencePinsEntregas-spin"
                : ""
            }
          />

          Atualizar
        </button>
      </header>

      {erro && (
        <div className="experiencePinsEntregas-alert erro">
          {erro}
        </div>
      )}

      {sucesso && (
        <div className="experiencePinsEntregas-alert sucesso">
          <CheckCircle2 size={17} />
          {sucesso}
        </div>
      )}

      <section className="experiencePinsEntregas-toolbar">
        <label className="experiencePinsEntregas-field campanha">
          <span>Campanha</span>

          <select
            value={campanhaId}
            onChange={(event) => {
              setCampanhaId(
                event.target.value
              );
              setPagina(1);
            }}
            disabled={loadingCampanhas}
          >
            {!campanhas.length && (
              <option value="">
                Nenhuma campanha
              </option>
            )}

            {campanhas.map(
              (campanha) => (
                <option
                  key={campanha.id}
                  value={campanha.id}
                >
                  {campanha.nome}
                </option>
              )
            )}
          </select>
        </label>

        <label className="experiencePinsEntregas-field">
          <span>Ano</span>

          <input
            type="number"
            min="2020"
            max="2100"
            value={ano}
            onChange={(event) => {
              setAno(
                Number(
                  event.target.value
                )
              );
              setPagina(1);
            }}
          />
        </label>

        <label className="experiencePinsEntregas-field">
          <span>Mês</span>

          <select
            value={mes}
            onChange={(event) => {
              setMes(
                Number(
                  event.target.value
                )
              );
              setPagina(1);
            }}
          >
            {MESES.map(
              (nome, indice) => (
                <option
                  key={nome}
                  value={indice + 1}
                >
                  {nome}
                </option>
              )
            )}
          </select>
        </label>

        <label className="experiencePinsEntregas-field">
          <span>PIN</span>

          <select
            value={pinId}
            onChange={(event) => {
              setPinId(
                event.target.value
              );
              setPagina(1);
            }}
          >
            <option value="">
              Todos
            </option>

            {pins.map((pin) => (
              <option
                key={pin.id}
                value={pin.id}
              >
                {pin.nome}
              </option>
            ))}
          </select>
        </label>

        <label className="experiencePinsEntregas-field">
          <span>Status</span>

          <select
            value={statusPin}
            onChange={(event) => {
              setStatusPin(
                event.target.value
              );
              setPagina(1);
            }}
          >
            {STATUS_PIN.map(
              (item) => (
                <option
                  key={item.value}
                  value={item.value}
                >
                  {item.label}
                </option>
              )
            )}
          </select>
        </label>

        <label className="experiencePinsEntregas-field">
          <span>Tipo de entrega</span>

          <select
            value={tipoEntrega}
            onChange={(event) => {
              setTipoEntrega(
                event.target.value
              );
              setPagina(1);
            }}
          >
            {TIPOS_ENTREGA.map(
              (item) => (
                <option
                  key={item.value}
                  value={item.value}
                >
                  {item.label}
                </option>
              )
            )}
          </select>
        </label>

        <div className="experiencePinsEntregas-search">
          <Search size={16} />

          <input
            value={busca}
            onChange={(event) =>
              setBusca(
                event.target.value
              )
            }
            onKeyDown={(event) => {
              if (
                event.key === "Enter"
              ) {
                aplicarBusca();
              }
            }}
            placeholder="Cliente, ID, empresa, PIN ou rastreio"
          />

          <button
            type="button"
            onClick={aplicarBusca}
          >
            Buscar
          </button>
        </div>

        <button
          type="button"
          className="experiencePinsEntregas-clearButton"
          onClick={limparFiltros}
        >
          <Filter size={15} />
          Limpar
        </button>
      </section>

      <section className="experiencePinsEntregas-cards">
        {cards.map(
          ({
            titulo,
            valor,
            legenda,
            Icone,
            classe
          }) => (
            <article
              key={titulo}
              className={`experiencePinsEntregas-card ${classe}`}
            >
              <div>
                <Icone size={20} />
              </div>

              <span>{titulo}</span>
              <strong>{valor}</strong>
              <small>{legenda}</small>
            </article>
          )
        )}
      </section>

      <section className="experiencePinsEntregas-tablePanel">
        <div className="experiencePinsEntregas-tableHeader">
          <div>
            <h2>
              Fluxo logístico
            </h2>

            <p>
              {Number(
                paginacao.total_registros ||
                  0
              )}{" "}
              registros encontrados.
            </p>
          </div>

          <div className="experiencePinsEntregas-summaryPills">
            <span>
              Envios:{" "}
              <strong>
                {dados?.cards
                  ?.total_envios || 0}
              </strong>
            </span>

            <span>
              Retiradas:{" "}
              <strong>
                {dados?.cards
                  ?.total_retiradas || 0}
              </strong>
            </span>

            <span>
              Sem dados:{" "}
              <strong>
                {dados?.cards
                  ?.sem_dados_logisticos ||
                  0}
              </strong>
            </span>
          </div>
        </div>

        <div className="experiencePinsEntregas-tableWrapper">
          <table className="experiencePinsEntregas-table">
            <thead>
              <tr>
                <th />
                <th>Cliente</th>
                <th>Competência</th>
                <th>PIN</th>
                <th>Status</th>
                <th>Tipo</th>
                <th>Destino</th>
                <th>Rastreio</th>
                <th>Atualização</th>
                <th>Ações</th>
              </tr>
            </thead>

            <tbody>
              {entregas.map(
                (registro) => {
                  const aberta =
                    Boolean(
                      linhasAbertas[
                        registro
                          .conquista_id
                      ]
                    );

                  const imagemPin =
                    getPinImage(
                      registro.pin
                    );

                  const entrega =
                    registro.entrega;

                  const endereco =
                    entrega?.endereco;

                  const destino =
                    entrega?.tipo ===
                    "RETIRADA"
                      ? "Retirada"
                      : [
                          endereco?.cidade,
                          endereco?.estado
                        ]
                          .filter(Boolean)
                          .join(" / ") ||
                        "Não informado";

                  return (
                    <React.Fragment
                      key={
                        registro
                          .conquista_id
                      }
                    >
                      <tr>
                        <td>
                          <button
                            type="button"
                            className="experiencePinsEntregas-expandButton"
                            onClick={() =>
                              alternarLinha(
                                registro
                                  .conquista_id
                              )
                            }
                          >
                            {aberta ? (
                              <ChevronUp
                                size={16}
                              />
                            ) : (
                              <ChevronDown
                                size={16}
                              />
                            )}
                          </button>
                        </td>

                        <td>
                          <strong>
                            {
                              registro
                                .cliente.nome
                            }
                          </strong>

                          <small>
                            ID{" "}
                            {
                              registro
                                .cliente.id
                            }{" "}
                            •{" "}
                            {
                              registro
                                .cliente.email
                            }
                          </small>

                          <small>
                            {registro.empresa
                              ?.nome ||
                              "Empresa não vinculada"}
                          </small>
                        </td>

                        <td>
                          <strong>
                            {String(
                              registro
                                .competencia.mes
                            ).padStart(
                              2,
                              "0"
                            )}
                            /
                            {
                              registro
                                .competencia.ano
                            }
                          </strong>

                          <small>
                            {formatarDinheiro(
                              registro
                                .volume_apurado
                            )}
                          </small>
                        </td>

                        <td>
                          <div className="experiencePinsEntregas-pinCell">
                            {imagemPin && (
                              <img
                                src={imagemPin}
                                alt={
                                  registro.pin
                                    .nome
                                }
                              />
                            )}

                            <strong>
                              {
                                registro.pin
                                  .nome
                              }
                            </strong>
                          </div>
                        </td>

                        <td>
                          <span
                            className={`experiencePinsEntregas-status ${String(
                              registro.pin
                                .status || ""
                            ).toLowerCase()}`}
                          >
                            {statusLabel(
                              registro.pin
                                .status
                            )}
                          </span>
                        </td>

                        <td>
                          <span className="experiencePinsEntregas-type">
                            {entrega?.tipo ===
                            "RETIRADA"
                              ? "Retirada"
                              : "Envio"}
                          </span>
                        </td>

                        <td>
                          <strong>
                            {destino}
                          </strong>

                          <small>
                            {entrega
                              ?.destinatario ||
                              registro.cliente
                                .nome}
                          </small>
                        </td>

                        <td>
                          <strong>
                            {entrega?.rastreio
                              ?.codigo || "-"}
                          </strong>

                          <small>
                            {entrega?.rastreio
                              ?.transportadora ||
                              "Sem transportadora"}
                          </small>
                        </td>

                        <td>
                          {formatarDataHora(
                            entrega
                              ?.atualizado_em ||
                              registro
                                .atualizado_em
                          )}
                        </td>

                        <td>
                          <button
                            type="button"
                            className="experiencePinsEntregas-editButton"
                            onClick={() =>
                              abrirEdicao(
                                registro
                                  .conquista_id
                              )
                            }
                          >
                            Gerenciar
                          </button>
                        </td>
                      </tr>

                      {aberta && (
                        <tr className="experiencePinsEntregas-expandedRow">
                          <td colSpan="10">
                            <div className="experiencePinsEntregas-expandedContent">
                              <div>
                                <span>
                                  Empresa
                                </span>

                                <strong>
                                  {registro.empresa
                                    ?.nome ||
                                    "Não vinculada"}
                                </strong>

                                <small>
                                  {formatarCnpj(
                                    registro
                                      .empresa?.cnpj
                                  )}
                                </small>
                              </div>

                              <div>
                                <span>
                                  Telefone
                                </span>

                                <strong>
                                  {entrega
                                    ?.telefone ||
                                    registro
                                      .cliente
                                      .telefone ||
                                    "-"}
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Endereço
                                </span>

                                <strong>
                                  {endereco
                                    ? [
                                        endereco
                                          .logradouro,
                                        endereco
                                          .numero,
                                        endereco
                                          .bairro,
                                        endereco
                                          .cidade,
                                        endereco
                                          .estado
                                      ]
                                        .filter(
                                          Boolean
                                        )
                                        .join(
                                          ", "
                                        ) || "-"
                                    : "-"}
                                </strong>
                              </div>

                              <div>
                                <span>
                                  CEP
                                </span>

                                <strong>
                                  {endereco?.cep ||
                                    "-"}
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Transportadora
                                </span>

                                <strong>
                                  {entrega
                                    ?.rastreio
                                    ?.transportadora ||
                                    "-"}
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Link de rastreio
                                </span>

                                {entrega
                                  ?.rastreio
                                  ?.link ? (
                                  <a
                                    href={
                                      entrega
                                        .rastreio
                                        .link
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Abrir link
                                    <ExternalLink
                                      size={13}
                                    />
                                  </a>
                                ) : (
                                  <strong>
                                    -
                                  </strong>
                                )}
                              </div>

                              <div>
                                <span>
                                  Produzido em
                                </span>

                                <strong>
                                  {formatarDataHora(
                                    entrega
                                      ?.datas
                                      ?.produzido_em
                                  )}
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Pronto em
                                </span>

                                <strong>
                                  {formatarDataHora(
                                    entrega
                                      ?.datas
                                      ?.pronto_em
                                  )}
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Enviado em
                                </span>

                                <strong>
                                  {formatarDataHora(
                                    entrega
                                      ?.datas
                                      ?.enviado_em
                                  )}
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Entregue em
                                </span>

                                <strong>
                                  {formatarDataHora(
                                    entrega
                                      ?.datas
                                      ?.entregue_em
                                  )}
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Retirado em
                                </span>

                                <strong>
                                  {formatarDataHora(
                                    entrega
                                      ?.datas
                                      ?.retirado_em
                                  )}
                                </strong>
                              </div>

                              <div className="experiencePinsEntregas-expandedWide">
                                <span>
                                  Observações
                                </span>

                                <strong>
                                  {entrega
                                    ?.observacoes ||
                                    "Nenhuma observação cadastrada."}
                                </strong>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                }
              )}
            </tbody>
          </table>

          {!loading &&
            entregas.length === 0 && (
              <div className="experiencePinsEntregas-empty">
                <Box size={29} />

                <h3>
                  Nenhuma entrega encontrada
                </h3>

                <p>
                  As entregas aparecerão aqui após
                  a criação das conquistas mensais.
                </p>
              </div>
            )}

          {loading && (
            <div className="experiencePinsEntregas-loading">
              <Loader2
                size={26}
                className="experiencePinsEntregas-spin"
              />

              <span>
                Carregando entregas...
              </span>
            </div>
          )}
        </div>

        <footer className="experiencePinsEntregas-pagination">
          <span>
            Página{" "}
            {paginacao.pagina || 1} de{" "}
            {paginacao.total_paginas ||
              1}
          </span>

          <div>
            <button
              type="button"
              onClick={() =>
                setPagina((atual) =>
                  Math.max(
                    1,
                    atual - 1
                  )
                )
              }
              disabled={
                Number(
                  paginacao.pagina || 1
                ) <= 1 ||
                loading
              }
            >
              <ChevronLeft size={16} />
              Anterior
            </button>

            <button
              type="button"
              onClick={() =>
                setPagina((atual) =>
                  Math.min(
                    Number(
                      paginacao
                        .total_paginas ||
                        1
                    ),
                    atual + 1
                  )
                )
              }
              disabled={
                Number(
                  paginacao.pagina || 1
                ) >=
                  Number(
                    paginacao
                      .total_paginas ||
                      1
                  ) ||
                loading
              }
            >
              Próxima
              <ChevronRight size={16} />
            </button>
          </div>
        </footer>
      </section>

      {modalAberto && (
        <div
          className="experiencePinsEntregas-modalOverlay"
          onMouseDown={(event) => {
            if (
              event.target ===
              event.currentTarget
            ) {
              fecharModal();
            }
          }}
        >
          <div className="experiencePinsEntregas-modal">
            <header className="experiencePinsEntregas-modalHeader">
              <div>
                <span className="experiencePinsEntregas-kicker">
                  Operação logística
                </span>

                <h2>
                  Gerenciar entrega do PIN
                </h2>
              </div>

              <button
                type="button"
                onClick={fecharModal}
                disabled={salvando}
              >
                <X size={18} />
              </button>
            </header>

            {loadingDetalhe ? (
              <div className="experiencePinsEntregas-modalLoading">
                <Loader2
                  size={26}
                  className="experiencePinsEntregas-spin"
                />

                <span>
                  Carregando detalhes...
                </span>
              </div>
            ) : detalhe ? (
              <>
                <section className="experiencePinsEntregas-modalSummary">
                  <div className="experiencePinsEntregas-modalPin">
                    {getPinImage(
                      detalhe.pin
                    ) && (
                      <img
                        src={getPinImage(
                          detalhe.pin
                        )}
                        alt={
                          detalhe.pin.nome
                        }
                      />
                    )}
                  </div>

                  <div>
                    <span>
                      {
                        detalhe.cliente
                          .nome
                      }
                    </span>

                    <h3>
                      PIN{" "}
                      {detalhe.pin.nome}
                    </h3>

                    <p>
                      Competência{" "}
                      {String(
                        detalhe.conquista
                          .mes
                      ).padStart(
                        2,
                        "0"
                      )}
                      /
                      {
                        detalhe.conquista
                          .ano
                      }
                    </p>
                  </div>
                </section>

                <div className="experiencePinsEntregas-formGrid">
                  <label className="experiencePinsEntregas-modalField">
                    <span>Status do PIN</span>

                    <select
                      value={
                        form.status_pin
                      }
                      onChange={(event) =>
                        atualizarCampo(
                          "status_pin",
                          event.target.value
                        )
                      }
                    >
                      {STATUS_PIN
                        .filter(
                          (item) =>
                            item.value
                        )
                        .map((item) => (
                          <option
                            key={item.value}
                            value={item.value}
                          >
                            {item.label}
                          </option>
                        ))}
                    </select>
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Tipo de entrega</span>

                    <select
                      value={
                        form.tipo_entrega
                      }
                      onChange={(event) =>
                        atualizarCampo(
                          "tipo_entrega",
                          event.target.value
                        )
                      }
                    >
                      {TIPOS_ENTREGA
                        .filter(
                          (item) =>
                            item.value
                        )
                        .map((item) => (
                          <option
                            key={item.value}
                            value={item.value}
                          >
                            {item.label}
                          </option>
                        ))}
                    </select>
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Destinatário</span>

                    <input
                      value={
                        form.destinatario
                      }
                      onChange={(event) =>
                        atualizarCampo(
                          "destinatario",
                          event.target.value
                        )
                      }
                      maxLength={180}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Telefone</span>

                    <input
                      value={form.telefone}
                      onChange={(event) =>
                        atualizarCampo(
                          "telefone",
                          event.target.value
                        )
                      }
                      maxLength={30}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>CEP</span>

                    <input
                      value={form.cep}
                      onChange={(event) =>
                        atualizarCampo(
                          "cep",
                          event.target.value
                        )
                      }
                      maxLength={10}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Logradouro</span>

                    <input
                      value={form.logradouro}
                      onChange={(event) =>
                        atualizarCampo(
                          "logradouro",
                          event.target.value
                        )
                      }
                      maxLength={180}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Número</span>

                    <input
                      value={form.numero}
                      onChange={(event) =>
                        atualizarCampo(
                          "numero",
                          event.target.value
                        )
                      }
                      maxLength={20}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Complemento</span>

                    <input
                      value={form.complemento}
                      onChange={(event) =>
                        atualizarCampo(
                          "complemento",
                          event.target.value
                        )
                      }
                      maxLength={120}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Bairro</span>

                    <input
                      value={form.bairro}
                      onChange={(event) =>
                        atualizarCampo(
                          "bairro",
                          event.target.value
                        )
                      }
                      maxLength={120}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Cidade</span>

                    <input
                      value={form.cidade}
                      onChange={(event) =>
                        atualizarCampo(
                          "cidade",
                          event.target.value
                        )
                      }
                      maxLength={120}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Estado</span>

                    <input
                      value={form.estado}
                      onChange={(event) =>
                        atualizarCampo(
                          "estado",
                          event.target.value
                            .toUpperCase()
                        )
                      }
                      maxLength={2}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Transportadora</span>

                    <input
                      value={
                        form.transportadora
                      }
                      onChange={(event) =>
                        atualizarCampo(
                          "transportadora",
                          event.target.value
                        )
                      }
                      maxLength={150}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Código de rastreio</span>

                    <input
                      value={
                        form.codigo_rastreio
                      }
                      onChange={(event) =>
                        atualizarCampo(
                          "codigo_rastreio",
                          event.target.value
                        )
                      }
                      maxLength={150}
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField">
                    <span>Link de rastreio</span>

                    <input
                      value={
                        form.link_rastreio
                      }
                      onChange={(event) =>
                        atualizarCampo(
                          "link_rastreio",
                          event.target.value
                        )
                      }
                      maxLength={500}
                      placeholder="https://..."
                    />
                  </label>

                  <label className="experiencePinsEntregas-modalField full">
                    <span>Observações</span>

                    <textarea
                      value={
                        form.observacoes
                      }
                      onChange={(event) =>
                        atualizarCampo(
                          "observacoes",
                          event.target.value
                        )
                      }
                      rows={4}
                    />
                  </label>
                </div>

                <footer className="experiencePinsEntregas-modalFooter">
                  <button
                    type="button"
                    className="experiencePinsEntregas-secondaryButton"
                    onClick={fecharModal}
                    disabled={salvando}
                  >
                    Cancelar
                  </button>

                  <button
                    type="button"
                    className="experiencePinsEntregas-primaryButton"
                    onClick={salvarEntrega}
                    disabled={salvando}
                  >
                    {salvando ? (
                      <Loader2
                        size={17}
                        className="experiencePinsEntregas-spin"
                      />
                    ) : (
                      <CheckCircle2
                        size={17}
                      />
                    )}

                    Salvar alterações
                  </button>
                </footer>
              </>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}

